import { useLocation, Navigate } from 'react-router-dom';
import { usePermissions } from './usePermissions';
import Forbidden from 'views/errors/Forbidden';
import { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
const PermissionGuard = ({ children, requiredPermissions = [], requiredUserTypes = null }) => {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const auth = {
    user: localStorage.getItem('userToken'),
    userRole: localStorage.getItem('userRole'),
    permissions: localStorage.getItem('userPermissions')
  };
  const userPermissions = JSON.parse(auth?.permissions);
  const userRole = JSON.parse(auth?.userRole);

  // Role-restricted routes (e.g. the client profile is limited to head coaches
  // (userType 5) + super admin (1)). Enforce this BEFORE the userType 4/5
  // bypass below, otherwise a trainer (4) with no granular permissions would
  // slip through. Skip when unauthenticated so the login redirect still runs.
  if (auth?.user && Array.isArray(requiredUserTypes) && !requiredUserTypes.includes(userRole?.userType)) {
    return <Forbidden />;
  }

  if ((userRole?.userType === 4 || userRole?.userType === 5) && (userPermissions?.length === 0 || userPermissions === null)) {
    return children;
  }

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermissions = async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };
    checkPermissions();
  }, []);

  // First check if user is authenticated
  if (!auth?.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Show loading state while checking permissions
  if (loading) {
    return (
      <>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  // Then check if user has required permissions
  const hasRequiredPermissions = requiredPermissions.length === 0 || requiredPermissions.some((permission) => hasPermission(permission));

  if (!hasRequiredPermissions) {
    return <Forbidden />;
  }

  return children;
};

export default PermissionGuard;
